import { API, Auth } from "aws-amplify";
import {
  onCreateAppConfig,
  onUpdateAppConfig,
  onDeleteAppConfig,
} from "@/graphql/subscriptions";
import store from "@/store";
import { parseGraphqlResult } from "@/core/utils/parseGraphqlResult";

export default {
  async install() {
    const authMode = (await Auth.currentAuthenticatedUser().catch(() => {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
    }))
      ? "AMAZON_COGNITO_USER_POOLS"
      : "AWS_IAM";

    API.graphql({
      query: onCreateAppConfig,
      authMode,
    }).subscribe({
      next: (event) => {
        const createdConfig = parseGraphqlResult(
          event.value.data.onCreateAppConfig,
        );
        store.commit("setAppConfig", {
          key: createdConfig.key,
          config: createdConfig,
        });
      },
      error: (error) =>
        console.warn("AppConfig create subscription error:", error),
    });

    API.graphql({
      query: onUpdateAppConfig,
      authMode,
    }).subscribe({
      next: (event) => {
        const updatedConfig = parseGraphqlResult(
          event.value.data.onUpdateAppConfig,
        );
        store.commit("setAppConfig", {
          key: updatedConfig.key,
          config: updatedConfig,
        });
      },
      error: (error) =>
        console.warn("AppConfig update subscription error:", error),
    });

    API.graphql({
      query: onDeleteAppConfig,
      authMode,
    }).subscribe({
      next: (event) => {
        const deletedConfig = parseGraphqlResult(
          event.value.data.onDeleteAppConfig,
        );
        store.commit("setAppConfig", { key: deletedConfig.key, config: null });
      },
      error: (error) =>
        console.warn("AppConfig delete subscription error:", error),
    });
  },
};
